// extracted by mini-css-extract-plugin
module.exports = {"imgB":"imgB_imgB__HZzZq"};